import Request from 'gd-request';

export default class ApiTag {

    universalTaskRequest(tagId, systemStatus, fields) {
        // GET http://{{api-app}}/tag/Be3MhR/tasks-new?cid=U48GJt&systemStatus=all&tags&timeReports&taskUsers&projectDeadlines&predecessors&successors

        const params = {
            systemStatus: systemStatus,
        }

        _.map(fields, field => params[field] = true)

        return new Request(this,'GET','tag/{0}/tasks'.f(tagId), params);
    }
}